<template>
    <div id="core_waybills">
        <div class="ui segment">
            <div style="display: flex; justify-content: space-between;flex-wrap: wrap;">
                <Receipts
                    v-if="!is_fetching_data && node.company_en_name && show_receipts"
                    :show_buttons="true"
                    :buttons_type="node.identity == '6896bd65c1-28036-39768292' ? 'select' : 'button'"
                    :assigned_core_waybills="core_waybills"
                    :logo_url="`/images/${node.company_en_name.replace(/(?:^|\.|\s?)([A-Z])/g, (x,y) => {return '_' + y.toLowerCase()}).replace(/^_/, '')}_logo.jpg`"
                    :title="`${node.company_short_name}客戶簽收單`"
                    :sub_title="node.website_url"
                    :customer_service_hotline="node.customer_service_hotline"
                    :logistician="current_staff"
                    :location="''">
                </Receipts>
                <div v-else></div>
                <div :style="(
                    !is_fetching_data &&
                    node.company_en_name &&
                    show_receipts &&
                    style.width < (is_show_filter.detail
                        ? (node.identity == '6896bd65c1-28036-39768292' ? 385 : 530)
                        : (node.identity == '6896bd65c1-28036-39768292' ? 877 : 1075))
                    ) ? {
                        width: '100%',
                        marginTop: '9px',
                        textAlign: 'right',
                    } : {}">
                    <!--
                    * ========================================================================
                    * = 純號碼 無展開 detail filter 時顯示
                    * ========================================================================
                    -->
                    <div v-if="!is_show_filter.detail" style="display: inline;">
                        <div class="ui right labeled left icon input">
                            <i class="search icon"></i>
                            <input
                                v-if="current_store.quick_filter_key.number == 'operation_number'"
                                @change="$forceUpdate()"
                                @keypress.enter="core_waybills_filter()"
                                v-model="filter.operation.number"
                                type="text"
                                :placeholder="$t('ui.pages.core_waybills.filter.find__key', {
                                    key: $t('models.attributes.core_waybills.'+current_store.quick_filter_key.number)
                                })"
                            >
                            <input
                                v-else
                                @change="$forceUpdate()"
                                @keypress.enter="core_waybills_filter()"
                                v-model="filter[current_store.quick_filter_key.number]"
                                type="text"
                                :placeholder="$t('ui.pages.core_waybills.filter.find__key', {
                                    key: $t('models.attributes.core_waybills.'+current_store.quick_filter_key.number)
                                })"
                            >
                            <div class="ui dropdown label no_search" v-dropdown>
                                <div class="text"
                                    v-for="item in current_store.quick_filters.number"
                                    v-if="current_store.quick_filter_key.number == item">
                                    {{ $t('models.attributes.core_waybills.'+item) }}
                                </div>
                                <i class="dropdown icon"></i>
                                <div class="menu">
                                    <div class="item"
                                        v-for="item in current_store.quick_filters.number"
                                        :class="{'selected active': current_store.quick_filter_key.number == item }"
                                        @click="set_quick_filter_key('number', item)"
                                        >
                                        {{ $t('models.attributes.core_waybills.'+item) }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!--
                    * ========================================================================
                    * = 展開 detail filter 才顯示
                    * ========================================================================
                    -->
                    <div v-if="is_show_filter.detail" style="display: inline;">
                        <div
                            class="ui basic red icon button"
                            @click="$store.dispatch('provider/core_waybills_module/clear_filter',{
                                operation_number: ($route.params.operation_number || null)
                            })">
                            <i class="close icon"></i>
                        </div>
                    </div>

                    <!--
                    * ========================================================================
                    * = 切換 filter style, 一直顯示
                    * ========================================================================
                    -->
                    <div class="ui icon buttons" style="
                        vertical-align: top;
                        margin: 0 6px;
                        height: 37px;
                        ">
                        <div class="ui button"
                            :data-tooltip="$t('ui.general.simple')"
                            :class="{active: is_show_filter.simple}"
                            @click="toggle_filter('simple')">
                            <i class="bars left icon"></i>
                        </div>
                        <div class="ui button"
                            :data-tooltip="$t('ui.general.advanced')"
                            :class="{active: is_show_filter.detail}"
                            @click="toggle_filter('detail')">
                            <i class="file alternate icon"></i>
                        </div>
                        <div class="ui button"
                            v-if="!is_show_filter.detail"
                            :data-tooltip="$t('ui.pages.core_waybills.filter.asynchronous')"
                            :class="{active: current_store.is_filter_async}"
                            @click="current_store.is_filter_async = !current_store.is_filter_async">
                            <i class="cloud icon" :class="{'upload': current_store.is_filter_async}"></i>
                        </div>
                    </div>
                </div>
            </div>

            <div :style="{position:'relative', paddingTop: is_any_filter_show ? '12px' : null }">
                <transition name="slide-fade" mode="out-in">
                    <div class="ui top right attached label active"
                        v-if="is_show_filter.detail"
                        style="top:3px;right: 6px;border-radius: .2rem;">
                        <div class="ui checkbox" v-checkbox>
                            <i class="big cloud icon"
                                style="position: absolute;top: -5px; left: -8px; color: #acacac;">
                            </i>
                            <input type="checkbox" tabindex="0" class="hidden" v-model="current_store.is_filter_async">
                            <label>{{ $t('ui.pages.core_waybills.filter.asynchronous') }}</label>
                        </div>
                    </div>
                </transition>
                <transition name="slide-fade" mode="out-in">
                    <SimpleFilter v-if="is_show_filter.simple">
                    </SimpleFilter>
                </transition>
                <transition name="slide-fade" mode="out-in">
                    <DetailFilter v-if="is_show_filter.detail">
                    </DetailFilter>
                </transition>
            </div>

            <div class="right floated"
                :style="{paddingTop: is_any_filter_show ? '12px' : null }"
                v-if="is_any_filter_show">
                <div v-if="current_store.is_can_print_label && !error_message"
                    style="display: inline-block; vertical-align: bottom;">
                    <div v-if="tool_label.numbers" style="display: inline-block;">
                        <div style="display: inline-block; vertical-align: bottom;">
                            <span v-if="$store.state.language == 'en-US'">
                                Total: {{ tool_label.core_waybill_length }}
                            </span>
                            <span v-else>
                                共 {{ tool_label.core_waybill_length }} 件
                            </span>
                        </div>
                        <CoreWaybillsLabelSvg
                            style="text-align: left; display: inline-block; vertical-align: middle;"
                            v-if="tool_label.numbers.length >= 1"
                            :numbers="tool_label.numbers"
                            :printing_type="tool_label.label_name"
                            :authentication_token="token"
                            :scope="'provider'"
                            :is_show_input="false"
                            :is_post_method="true"
                            :node_carrier_name="$store.state.provider.node.carrier_class"
                            >
                        </CoreWaybillsLabelSvg>
                    </div>
                    <div v-else
                        class="field" style="display: inline-block; vertical-align: bottom;">
                        <label>&emsp;</label>
                        <div class="ui button" @click="fetch_core_waybills_pagination_false()">
                            <i class="icon"
                                :class="is_processing_by_core_waybills_pagination_false ? 'circle notch loading' : 'print'"
                            ></i>
                            {{ $t('ui.pages.core_waybills.print_filter_result_labels') }}
                        </div>
                    </div>
                </div>

                <!-- 一般 -->
                <!-- <div class="ui button" @click="fetch_core_waybills_csv()">
                    <i class="file icon"></i>
                    {{ $t('ui.pages.core_waybills.export_csv_file') }}
                </div> -->

                <div v-if="converters_group_by_category.export && converters_group_by_category.export.length > 1"
                    class="ui buttons"
                    style="padding: 0 12px;">
                    <div class="ui button" @click="export_core_waybills(current_converter.identity)"
                        :data-tooltip="current_converter.note"
                        :data-position="'bottom left'">
                        <i class="file icon"></i>
                        {{ current_converter.name }}
                    </div>
                    <div class="ui floating dropdown icon button" v-dropdown
                        style="background: #c0c1c2;">
                        <i class="dropdown icon"></i>
                        <div class="menu">
                            <div class="item"
                                v-for="converter in converters_group_by_category.export"
                                @click="current_converter = converter">
                                {{ converter.name }}
                            </div>
                        </div>
                    </div>
                </div>
                <div v-else class="ui button" @click="export_core_waybills()">
                    <i class="file icon"></i>
                    匯出報表
                </div>

                <!-- 清關 -->
                <div class="ui button"
                    @click="fetch_core_waybills_csv('clearance')"
                    v-if="hostname == 'forever.tw568.com'">
                    <i class="file alternate outline icon"></i>
                    {{ $t('ui.pages.core_waybills.export_clearance_csv_file') }}
                </div>

                <!-- 當日報表 (依照node不同而顯示)-->
                <a class="ui button" v-if="current_store.csv.url" :href="current_store.csv.url">
                    <i class="download icon"></i>
                    {{ $t('ui.pages.core_waybills.download_daily_csv_file') }}
                </a>
                <div class="ui icon button" v-if="current_store.csv.url" @click="current_store.csv.url = null">
                    <i class="refresh icon"></i>
                </div>

                <div class="ui button"
                    v-else-if="(hostname == 'cqf.tw568.com') || (hostname == 'local.mynet.com.tw')"
                    @click="fetch_core_waybills_csv_new()"
                    :class="{loading: current_store.csv.is_processing}"
                    >
                    <span style="position: relative;" v-if="!current_store.csv.is_processing">
                        <i class="file outline icon"></i>
                        <i class="red small code icon" style="position: absolute; right: 4px;bottom: 0;"></i>
                    </span>
                    {{ $t('ui.pages.core_waybills.export_daily_csv_file') }}
                </div>

                <div
                    v-if="is_any_filter_show"
                    class="ui icon blue button"
                    @click="() => {if(!is_processing){core_waybills_filter()}}">
                    <i class="icon" :class="is_processing ? 'circle notch loading' : 'search'"></i>
                    {{ $t('ui.general.search') }}
                </div>
            </div>
            <div class="clear"></div>
        </div>

        <div v-if="!is_initialized || is_processing"
            class="ui segments core_waybill"
            style="text-align:center; height:100px;">
            <div class="ui active inverted dimmer">
                <div class="ui text loader">
                    <h3>
                        {{ $t('ui.general.initializing') }}
                    </h3>
                </div>
            </div>
        </div>
        <div v-else-if="error_message"
            class="ui red raised segment center aligned">
            <h2>
                {{ error_message }}
            </h2>
        </div>
        <div v-else>
            <CoreWaybill
                v-if="is_initialized"
                v-for="core_waybill in core_waybills"
                :key="core_waybill.identity"
                :core_waybill="core_waybill"
                :template="'card'"
                :is_auto_print="false"
                :is_can_update="false"
                :is_can_print_label="false"
                :is_show_change_template_btns="false"
                :cant_update_field_names="[]"
                :active_button="{
                    to_detail_route_name: ($route.params.operation_number) ? 'edit_core_waybill_operation' :'edit_core_waybill'
                }"
                :card="{
                    is_simple_form: false,
                    is_half_style: true,
                    is_show_note: true,
                    is_vertical: true,
                }"
            >
            </CoreWaybill>
            <div class="clear"></div>
            <div v-if="core_waybills.length == 0"
                class="ui green raised segment center aligned">
                <h2>
                    {{ $t('ui.pages.core_waybills.can_start_by_search') }}
                    <!-- 可以開始搜尋運單使用 -->
                </h2>
            </div>
        </div>

        <Paginator
            v-if="current_store.total_pages > 1"
            current_module_name="core_waybills_module"
            :total_pages="current_store.total_pages"
            :current_page="current_store.current_page"
        />
        <!-- <Supervisor></Supervisor> -->
    </div>
</template>

<script>
import CoreWaybillsLabelSvg from "@toolbox/core_waybills_label_svg/main.vue"
import DetailFilter from "@core_waybills/.components/provider/filter/detail.vue"
import SimpleFilter from "@core_waybills/.components/provider/filter/simple.vue"
import CoreWaybill from '@toolbox/core_waybill/main.vue'
import Paginator from '@toolbox/pagination/paginator.vue'
import Receipts from "@toolbox/receipts/main.vue"
import Supervisor from "@toolbox/supervisor/main.vue"

export default {
    name: "CoreWaybillsIndex",
    data() {
        return {
            is_initialized: false,
            is_fetching_data: false,
            is_processing: true,
            is_processing_by_core_waybills_pagination_false: false,
            error_message: "",
            current_converter: {},
            converters_group_by_category: [],
        }
    },
    computed: {
        hostname() {
            return window.location.hostname
        },
        style() {
            return this.$store.state.style
        },
        current_store() {
            return this.$store.state.provider.core_waybills_module
        },
        tool_label() {
            return this.current_store.tool_label
        },
        core_waybills() {
            return this.current_store.core_waybills
        },
        filter() {
            return this.current_store.filter
        },
        is_show_filter() {
            return this.current_store.is_show_filter
        },
        is_any_filter_show() {
            return this.is_show_filter.simple || this.is_show_filter.detail
        },
        node() {
            return this.$store.state.provider.node
        },
        current_staff() {
            return this.$store.state.provider.current_staff
        },
        token() {
            return localStorage.getItem("authentication_token")
        },
        current_service_name() {
            return this.$store.state.provider.node.service_name
        },
        show_receipts() {
            return ["neuron", "neuron_premium"].includes(this.current_service_name)
        }
    },
    created() {
    },
    mounted() {
        this.init()

        this.$bus.$off('init')
        this.$bus.$on('init', (value = false) => {
            this.init()
        })
    },
    beforeDestroy() {
        this.$bus.$off('init')
        this.current_store.current_page = 1
    },
    watch: {
        '$route'(to, from) {
            this.init(false)
        },
        'is_show_filter.simple'(value) {
            if (value) {
                this.current_store.is_where_like_filter_mode = false
                this.is_show_filter.detail = false
            } else {
                this.$store.dispatch('provider/core_waybills_module/set_filter_init')
            }
        },
        'is_show_filter.detail'(value) {
            if (value) {
                this.current_store.is_where_like_filter_mode = true
                this.is_show_filter.simple = false
            } else {
                this.current_store.is_where_like_filter_mode = false
                this.$store.dispatch('provider/core_waybills_module/set_filter_init')
            }
        },
    },
    methods: {
        toggle_filter(style = false) {
            if (style == false) {
                this.is_show_filter.simple = false
                this.is_show_filter.detail = false
            } else {
                this.is_show_filter[style] = !this.is_show_filter[style]
            }
        },
        async init(is_first = true) {
            try {
                let dispatch_key_name = 'provider/core_waybills_module/'
                await new Promise(resolve => {
                    this.is_initialized = false
                    this.is_processing = true
                    this.error_message = ""
                    resolve()
                })

                if (is_first) {
                    await this.$store.dispatch(dispatch_key_name+'set_filter_init')
                    this.is_show_filter.simple = false
                    this.is_show_filter.detail = false
                }
                await new Promise(resolve => {
                    this.filter.operation.number = this.$route.params.operation_number || null
                    resolve()
                })
                await this.$store.dispatch(dispatch_key_name+'handle_query_to_filter',{
                    query: this.$route.query
                })
                if (is_first) {
                    await this.$store.dispatch(dispatch_key_name+'handle_quick_filter_key')
                    await this.$store.dispatch(dispatch_key_name+'fetch_staffs')
                    await this.$store.dispatch(dispatch_key_name+'fetch_materials')
                    await this.$store.dispatch(dispatch_key_name+'fetch_scan_action_prototypes')
                    await this.$store.dispatch(dispatch_key_name+'fetch_converters')
                    // await this.$store.dispatch(dispatch_key_name+'fetch_condition_status_prototypes')

                    await new Promise(resolve => {
                        this.converters_group_by_category = _.groupBy(this.current_store.converters, "category") || {}
                        if (this.converters_group_by_category.export) {
                            this.current_converter = _.head(this.converters_group_by_category.export)
                        }
                        resolve()
                    })
                }
                if (!is_first) {
                    await this.$store.dispatch(dispatch_key_name+'fetch_core_waybills')
                } else {
                    let current_api_query = this.$store.getters[dispatch_key_name+'filter_to_api_query']()
                    let before_api_query = this.current_store.before_api_query
                    if (current_api_query != "page=1" && current_api_query != before_api_query) {
                        await this.$store.dispatch(dispatch_key_name+'fetch_core_waybills')
                    }
                }
            } catch (e) {
                console.log(e)
                this.handle_error_message(e)
            }
            await new Promise(resolve => {
                this.is_initialized = true
                this.is_processing = false
                resolve()
            })
        },
        async core_waybills_filter() {
            console.log('core_waybills_filter')
            try {
                let dispatch_key_name = 'provider/core_waybills_module/'
                let current_api_query = this.$store.getters[dispatch_key_name+'filter_to_api_query']()
                let before_api_query = this.current_store.before_api_query
                if (!this.current_store.is_filter_async) {
                    await new Promise(resolve => {
                        if (current_api_query != before_api_query) {
                            this.$router.push({
                                name: this.$router.name,
                                query: this.$store.getters[dispatch_key_name+'filter_to_query']
                            })
                        } else {
                            this.init(false)
                        }
                        this.current_store.before_api_query = _.cloneDeep(current_api_query)
                        resolve()
                    })
                } else {
                    await this.$store.dispatch(dispatch_key_name+'fetch_core_waybills_by_async')
                }
            } catch (e) {
                console.log(e)
                this.handle_error_message(e)
            }
            await new Promise(resolve => {
                this.is_processing = false
                resolve()
            })
        },
        set_quick_filter_key(key, name) {
            try {
                this.current_store.quick_filter_key[key] = name
                if (key != "status") {
                    _.forEach(this.current_store.quick_filters[key], (value) => {
                        this.filter[value] = null
                    })
                }

            } catch (e) {
                console.log(e)
            }
        },
        async fetch_core_waybills_pagination_false() {
            try {
                this.is_processing_by_core_waybills_pagination_false = true
                await this.$store.dispatch('provider/core_waybills_module/fetch_core_waybills_pagination_false')
            } catch (err) {
                switch (err) {
                    case 'fetch_core_waybills_pagination_false nothing filter':
                        break
                    case 'core_waybills_label_type_different':
                        this.error_message = this.$t('ui.notifications.error.__name',{
                            name: this.$t('models.core_waybills') + " " + this.$t('ui.toolbox.core_waybill.errors.label_type_error')
                        })
                        break
                    case 'fetch_core_waybills_pagination_false_error':
                        this.error_message = this.$t('ui.notifications.error.find__name',{
                            name: this.$t('ui.general.print')
                        })
                        break
                    default:
                    this.error_message = this.$t('ui.notifications.error.exception_error_please_contact_the_system_supplier') + ':' + err
                }

                if (this.error_message) {
                    this.$noty.error(this.error_message)
                }
            } finally {
                this.is_processing_by_core_waybills_pagination_false = false
            }
        },
        handle_error_message(err) {
            switch (err) {
                case 'Network Abnormality':
                    this.error_message = this.$t('ui.general.network_abnormality')+": "+
                        this.$t('ui.general.server_offline')
                    break

                case 'fetch_core_waybills_no_anything_core_waybills':
                    let mode_string_key = this.current_store.is_where_like_filter_mode
                        ? 'is_where_like_filter_mode'
                        : 'is_not_where_like_filter_mode'
                    this.error_message = `${this.$t('ui.pages.core_waybills.'+mode_string_key)}，${this.$t('ui.notifications.error.no_data')}`
                    break

                case 'fetch_core_waybills_failure':
                    this.error_message = this.$t('ui.notifications.error.find__name',{
                        name: this.$t('models.core_waybills')
                    })
                    break

                case 'fetch_staffs_failure':
                    this.error_message = this.$t('ui.notifications.error.find__name',{
                        name: this.$t('models.staffs')
                    })
                    break

                case 'fetch_materials_failure':
                    this.error_message = this.$t('ui.notifications.error.find__name',{
                        name: this.$t('models.materials')
                    })
                    break

                case 'fetch_scan_action_prototypes_failure':
                    this.error_message = this.$t('ui.notifications.error.find__name',{
                        name: this.$t('ui.pages.core_waybills.have_contained_status')
                    })
                    break

                case 'fetch_condition_status_prototypes_failure':
                    this.error_message = this.$t('ui.notifications.error.find__name',{
                        name: this.$t('models.status_prototypes')
                    })
                    break

                case 'fetch_core_waybills_svg_error':
                    this.error_message = this.$t('ui.notifications.error.__name',{
                        name: this.$t('ui.pages.core_waybills.export_csv_file')
                    })
                    break
                case 'fetch_core_waybills_csv_error':
                    this.error_message = this.$t('ui.notifications.error.__name',{
                        name: 'csv ' + this.$t('ui.general.file')
                    })
                    break
                case 'fetch_core_waybills_csv_loading':
                    this.error_message = 'csv loading'
                    break
                default:
                    this.error_message = this.$t('ui.notifications.error.exception_error_please_contact_the_system_supplier') + '：' + err
            }
            if (this.error_message) {
                this.$noty.error(this.error_message)
            }
        },
        async fetch_core_waybills_csv_new() {
            try {
                await this.$store.dispatch('provider/core_waybills_module/fetch_core_waybills_csv_new')
            } catch (e) {
                if (e == "success") {
                    this.$cable.subscriptions.create(
                        {
                            channel: 'DelayedJobChannel',
                            instance_identity: this.$store.state.instance_identity,
                        },
                        {
                            connected() {
                                console.log("DelayedJobChannel connected")
                            },
                            received(response) {
                                if (response.data.download_url) {
                                    this.current_store.csv.is_processing = false
                                    this.current_store.csv.url = response.data.download_url
                                }
                            }
                        }
                    )
                } else {
                    console.log(e)
                    this.handle_error_message(e)
                }
            }
            await new Promise(resolve => {
                this.is_processing = false
                resolve()
            })
        },
        export_core_waybills(converter_identity = null) {
            this.$store.dispatch('provider/core_waybills_module/export_core_waybills', {converter_identity: converter_identity})
        },
        async fetch_core_waybills_csv(type=null) {
            try {
                await this.$store.dispatch('provider/core_waybills_module/fetch_core_waybills_csv', {type:type})
            } catch (e) {
                console.log(e)
                this.handle_error_message(e)
            }
            await new Promise(resolve => {
                this.is_processing = false
                resolve()
            })
        },
    },
    components: {
        CoreWaybillsLabelSvg,
        DetailFilter,
        SimpleFilter,
        CoreWaybill,
        Paginator,
        Receipts,
        Supervisor,
    }
}
</script>

<style scoped lang="scss">
    div#paginator {
        text-align: right;
    }
    .blurry.icon {
        color:rgba(0,0,0,0);text-shadow:0 0 2px #666;
    }

    .signal {
        border: 5px solid white;
        border-radius: 30px;
        height: 30px;
        left: 50%;
        margin: -15px 0 0 -15px;
        opacity: 0;
        position: absolute;
        top: 50%;
        width: 30px;
        animation: pulsate 1s ease-out;
        animation-iteration-count: infinite;
    }
    @keyframes pulsate {
        0% {
            transform: scale(.1);
            opacity: 0.0;
        }
        50% {
            opacity: 1;
        }
        100% {
            transform: scale(1.4);
            opacity: 0;
        }
    }
</style>
